/**
 * 환경변수를 정의
 *
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-03-10
 */
export const ENV = {
  ENV: process.env.NODE_ENV || import.meta.env.VITE_ENV || "local",
  API_URL: import.meta.env.VITE_API_URL || null,
  ACCESS_TOKEN_KEY: import.meta.env.VITE_ACCESS_TOKEN_KEY || null,
  REFRESH_TOKEN_KEY: import.meta.env.VITE_REFRESH_TOKEN_KEY || null,
  PRE_FIX: import.meta.env.VITE_PRE_FIX || null,
  ADMIN_PATH: import.meta.env.VITE_ADMIN_PATH || null,
  APPS_PATH: import.meta.env.VITE_APPS_PATH || null,
  CUSTOMER_PATH: import.meta.env.VITE_CUSTOMER_PATH || null,
};
